import type { CPU } from '../CPU';
import { zsCheck } from './arithmetic';
import { H_IE } from './constants';

export function opAND(cpu: CPU): void {
  cpu.impl_operands[0].value &= cpu.impl_operands[1].value & 0xFF;
  zsCheck(cpu);
}

export function opOR(cpu: CPU): void {
  cpu.impl_operands[0].value |= cpu.impl_operands[1].value & 0xFF;
  zsCheck(cpu);
}

export function opXOR(cpu: CPU): void {
  cpu.impl_operands[0].value ^= cpu.impl_operands[1].value & 0xFF;
  zsCheck(cpu);
}

export function opMOV(cpu: CPU): void {
  cpu.impl_operands[0].value = cpu.impl_operands[1].value & 0xFF;
  zsCheck(cpu);
}

export function opMOV16(cpu: CPU): void {
  if (cpu.impl_hint & H_IE) {
    cpu.impl_operands[1].value |= (cpu.impl_operands[1].value & 0x40) ? 0xFF80 : 0;
  }
  cpu.impl_operands[0].value = cpu.impl_operands[1].value & 0xFF;
  zsCheck(cpu);

  const op_low_0 = cpu.impl_operands[0].value;
  cpu.impl_operands[0].value = (cpu.impl_operands[1].value >> 8) & 0xFF;
  zsCheck(cpu);

  cpu.impl_operands[0].value = (cpu.impl_operands[0].value << 8) | op_low_0;
}
